import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  IconLogo,
  IconClose,
  Link,
} from '@resy/ui-kitchen';
import AmexShopSmallHeaderLogin from './AmexShopSmallHeaderLogin';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexShopSmallHeader.scss';

const AmexShopSmallHeader = (
  {
    $location,
    $rootScope,
    Analytics,
    isAuthenticated,
    headerConfig: {
      naa: {
        text,
        link,
      },
    },
    handleTagging,
    matchMedia,
    tagConfig,
  }
) => {
  const isLinkBarHidden = JSON.parse(window.sessionStorage.getItem('isLinkBarHidden'));
  const [hideLinkBar, setHideLinkBar] = useState(Boolean(isLinkBarHidden));
  const {
    label: naaLabel,
    url: naaUrl,
  } = link;
  const {
    logo: logoEventName,
    naa: {
      event_name: naaEventName,
      utm: query,
    },
  } = tagConfig?.header;

  const hrefValue = `${naaUrl}${query}`;
  const {
    isScrolled,
    previewMode,
  } = $rootScope;

  const onLogoClick = () => {
    handleTagging(logoEventName);
    $location.path('/');
    $rootScope.$digest();
  };

  useEffect(() => {
    if (hideLinkBar) window.sessionStorage.setItem('isLinkBarHidden', 'true');
    return () => window.sessionStorage.removeItem('isLinkBarHidden');
  }, [hideLinkBar]);

  const sanitizedText = sanitizeString(text);

  const renderLinkBar = () => (
    <div
      className="AmexShopSmallHeader__linkbar"
      role="group"
      aria-label="NAA bar"
    >
      <div className="TopNav">
        <div className="container TopNav__container">
          <p className="AmexShopSmallHeader__linkbar-text">
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: sanitizedText,
              }}
            />
            <Link
              href={hrefValue}
              target="_blank"
              onClick={() => handleTagging(naaEventName)}
            >
              {naaLabel}
            </Link>
          </p>
          {!matchMedia.md && (
            <Button
              className="TopNav__close-icon"
              name="close"
              variant="close"
              aria-label="Close NAA bar"
              onClick={() => setHideLinkBar(true)}
            >
              <IconClose />
            </Button>
          )}
        </div>
      </div>
    </div>
  );

  const renderMobile = () => (
    <header
      aria-label="Main Resy"
      className={`AmexShopSmallHeader AmexShopSmallHeader--mobile ${isScrolled ? 'ResyNavShopSmall--scrolled' : ''}`}
    >
      {renderLinkBar()}
      <div
        className="ResyNavShopSmall__primary container"
      >
        <div
          className="ResyNavShopSmall__close-container"
        >
          <Button
            variant="no-style"
            type="button"
            className="ResyNavShopSmall__logo ResyNavShopSmall__logo--centre"
            aria-label="Resy Logo. Click to go home."
            onClick={() => { onLogoClick(); }}
          >
            <IconLogo width="77px" height="34px" />
          </Button>

          <div
            className="ResyNavShopSmall__close-container__spacer"
          />
        </div>
        <AmexShopSmallHeaderLogin
          $rootScope={$rootScope}
          Analytics={Analytics}
          isAuthenticated={isAuthenticated}
          matchMedia={matchMedia}
          tagConfig={tagConfig}
        />
      </div>
    </header>
  );
  const renderDesktop = () => (
    <header
      aria-label="Main Resy"
      className={`AmexShopSmallHeader AmexShopSmallHeader--desktop ${isScrolled ? 'ResyNavShopSmall--scrolled' : ''}`}
    >
      {renderLinkBar()}
      <div
        className={`${previewMode ? 'ResyNavDelta--disabled' : ''}`}
      />
      <div
        className="ResyNavShopSmall__container container"
      >
        <Button
          variant="no-style"
          type="button"
          className="ResyNavShopSmall__logo"
          aria-label="Resy Logo. Click to go home."
          onClick={() => { onLogoClick(); }}
        >
          <IconLogo width="77px" height="34px" />
        </Button>
        <AmexShopSmallHeaderLogin
          $rootScope={$rootScope}
          Analytics={Analytics}
          isAuthenticated={isAuthenticated}
          matchMedia={matchMedia}
          tagConfig={tagConfig}
        />
      </div>
    </header>
  );

  return (
    <div
      className={`ResyNavShopSmall ${isScrolled ? 'ResyNavShopSmall--scrolled' : ''} ${hideLinkBar ? 'linkbar--hidden' : 'linkbar--visible'}`}
    >
      {matchMedia.md ? renderDesktop() : renderMobile()}
    </div>
  );
};

AmexShopSmallHeader.propTypes = {
  $location: PropTypes.shape({
    path: PropTypes.func,
  }).isRequired,
  $rootScope: PropTypes.shape({
    $digest: PropTypes.func,
    nav: PropTypes.shape(),
    isScrolled: PropTypes.bool.isRequired,
    previewMode: PropTypes.bool.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  headerConfig: PropTypes.shape({
    naa: PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.shape({
        label: PropTypes.string,
        url: PropTypes.string,
      }),
    }),
  }).isRequired,
  handleTagging: PropTypes.func.isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  tagConfig: PropTypes.shape({
    header: PropTypes.shape({}),
  }).isRequired,
};

export default AmexShopSmallHeader;
